import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@/components/Modal';

export type CalendarReauthModalVariant = 'reminder' | 'report';

type CalendarReauthConfirmModalProps = {
    isOpen: boolean;
    onClose: () => void;
    /** OK 押下で OAuth 認可へ遷移 */
    onConfirm: () => void;
    variant: CalendarReauthModalVariant;
};

/**
 * 自動配信ON時、カレンダー再連携（OAuth）へ進む前の確認モーダル
 */
const CalendarReauthConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    variant,
}: CalendarReauthConfirmModalProps): ReactElement => {
    const { t } = useTranslation('scheduledReceipt');

    const bodyKey =
        variant === 'reminder' ? 'calendarReauthModal.bodyReminder' : 'calendarReauthModal.bodyReport';

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            contentClassName="w-full max-w-md p-6"
        >
            <h2 className="text-lg font-semibold text-gray-900 mb-3">
                {t('calendarReauthModal.title')}
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line mb-6">
                {t(bodyKey)}
            </p>
            <div className="flex justify-center">
                <button
                    type="button"
                    className="px-6 py-2 text-sm font-medium rounded-lg bg-kotomilThemaColor text-black border-2 border-kotomilThemaColor hover:bg-opacity-90 min-w-[120px]"
                    onClick={onConfirm}
                >
                    {t('calendarReauthModal.ok')}
                </button>
            </div>
        </Modal>
    );
};

export default CalendarReauthConfirmModal;
